import Vue from 'vue'
import Vuex from 'vuex'

import general from './modules/general/'
import auth from './modules/auth/'
import client from './modules/client/'
import company from './modules/company/'
import company_product from './modules/company_product/'
import contact from './modules/contact/';
import contact_type from './modules/contact_type/'
import role from './modules/role/'
import group from './modules/group/'
import user from './modules/user/'
import address from './modules/address/'
import category from './modules/category/'
import city from './modules/city/'
import country from './modules/country/'
import currency from './modules/currency/'
import language from './modules/language/'
import product from './modules/product/'
import post from './modules/post/'
import module from './modules/module/'
import backup from './modules/backup/'
import backup_status from './modules/backup_status/'
import backup_type from './modules/backup_type/'
import label from './modules/label/'
import condition from './modules/condition/'
import incoterm from './modules/incoterm/'
import product_price_type from './modules/product_price_type/'
import product_status from './modules/product_status/'

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    backup,
    backup_status,
    backup_type,
    general,
    address,
    category,
    city,
    country,
    currency,
    language,
    product,
    post,
    auth,
    condition,
    client,
    company,
    company_product,
    contact,
    contact_type,
    product_price_type,
    product_status,
    role,
    group,
    user,
    label,
    incoterm,
    module
  }
});
